import { render, staticRenderFns } from "./goods-toolbar.vue?vue&type=template&id=586473bc&"
import script from "./goods-toolbar.vue?vue&type=script&lang=ts&"
export * from "./goods-toolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports